'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_s_Product21__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.p3;
      break;
    }
    case 1: {
      return $thiz.pe;
      break;
    }
    case 2: {
      return $thiz.ph;
      break;
    }
    case 3: {
      return $thiz.pi;
      break;
    }
    case 4: {
      return $thiz.pj;
      break;
    }
    case 5: {
      return $thiz.pk;
      break;
    }
    case 6: {
      return $thiz.pl;
      break;
    }
    case 7: {
      return $thiz.pm;
      break;
    }
    case 8: {
      return $thiz.pn;
      break;
    }
    case 9: {
      return $thiz.p4;
      break;
    }
    case 10: {
      return $thiz.p5;
      break;
    }
    case 11: {
      return $thiz.p6;
      break;
    }
    case 12: {
      return $thiz.p7;
      break;
    }
    case 13: {
      return $thiz.p8;
      break;
    }
    case 14: {
      return $thiz.p9;
      break;
    }
    case 15: {
      return $thiz.pa;
      break;
    }
    case 16: {
      return $thiz.pb;
      break;
    }
    case 17: {
      return $thiz.pc;
      break;
    }
    case 18: {
      return $thiz.pd;
      break;
    }
    case 19: {
      return $thiz.pf;
      break;
    }
    case 20: {
      return $thiz.pg;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 20)"));
    }
  }
}
export { $f_s_Product21__productElement__I__O as $f_s_Product21__productElement__I__O };
